exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.previewsellItem[data-v-977ef370] {\r\n  position: relative;\n}\n.previewsellDItem p[data-v-977ef370]{\r\n  margin: 0;\n}\r\n", ""]);

// exports
